// extracted by mini-css-extract-plugin
module.exports = {"container":"prices-module--container--1y1ZR","cardsContainer":"prices-module--cards-container--Hm28-"};